export const REGULAR_ALLOCATION_TYPE_ID = 1;

export const REGULAR_ALLOCATION_TYPE = "Regular";

export const ATC_ALLOCATION_TYPE_ID = 2;

export const ATC_ALLOCATION_TYPE = "Alagang Tingog Center";

export const OTHERS_ALLOCATION_TYPE_ID = 3;

export const OTHERS_ALLOCATION_TYPE = "Others";

export const ADDITIONAL_ALLOCATION_TYPE_ID = 4;

export const ADDITIONAL_ALLOCATION_TYPE = "Additional";

export const CONTINUING_ALLOCATION_TYPE_ID = 5;

export const CONTINUING_ALLOCATION_TYPE = "Continuing";

export const ALLOCATION_TYPE_FILTER = [
  {
    label: REGULAR_ALLOCATION_TYPE,
    value: REGULAR_ALLOCATION_TYPE_ID,
  },
  {
    label: ATC_ALLOCATION_TYPE,
    value: ATC_ALLOCATION_TYPE_ID,
  },
  {
    label: OTHERS_ALLOCATION_TYPE,
    value: OTHERS_ALLOCATION_TYPE_ID,
  },
  {
    label: ADDITIONAL_ALLOCATION_TYPE,
    value: ADDITIONAL_ALLOCATION_TYPE_ID,
  },
  {
    label: CONTINUING_ALLOCATION_TYPE,
    value: CONTINUING_ALLOCATION_TYPE_ID,
  },
];

export const fundSourceDBMOptions = [
  {
    label: REGULAR_ALLOCATION_TYPE,
    value: REGULAR_ALLOCATION_TYPE,
  },
  {
    label: ADDITIONAL_ALLOCATION_TYPE,
    value: ADDITIONAL_ALLOCATION_TYPE,
  },
];

export const withOtherInfo = [
  REGULAR_ALLOCATION_TYPE_ID,
  OTHERS_ALLOCATION_TYPE_ID,
  ADDITIONAL_ALLOCATION_TYPE_ID,
];
